import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  active: true,
  ticketInsurance: {
    selected: false,
    touched: false,
    disabled: false,
    price: 0,
    healthy: true,
  },
};

const slice = createSlice({
  name: 'addons',
  initialState: reHydrateStore('addons') || initialState,
  reducers: {
    setAddOns: (state, { payload }) => ({ ...payload }),
    activeAddOns: (state, { payload }) => ({
      ...state,
      active: payload,
    }),
    addTicketInsurance: (state) => ({
      ...state,
      ticketInsurance: {
        ...state.ticketInsurance,
        selected: true,
        touched: true,
        disabled: false,
      },
    }),
    removeTicketInsurance: (state) => ({
      ...state,
      ticketInsurance: {
        ...state.ticketInsurance,
        selected: false,
        touched: true,
        disabled: false,
      },
    }),
    disableTicketInsurance: (state) => ({
      ...state,
      ticketInsurance: {
        ...state.ticketInsurance,
        selected: false,
        touched: false,
        disabled: true,
      },
    }),
    eneableTicketInsurance: (state) => ({
      ...state,
      ticketInsurance: {
        ...state.ticketInsurance,
        selected: false,
        touched: false,
        disabled: false,
      },
    }),
    setTicketInsurancePrice: (state, { payload }) => ({
      ...state,
      ticketInsurance: { ...state.ticketInsurance, price: payload },
    }),
    setNotHealthy: (state) => ({
      ...state,
      ticketInsurance: {
        selected: false,
        touched: false,
        disabled: true,
        healthy: false,
        price: 0,
      },
    }),
    restoreTicketInsurance: (state) => ({
      ...state,
      ticketInsurance: {
        ...state.ticketInsurance,
        selected: false,
        touched: false,
        disabled: false,
      },
    }),
    setAddons: (state, { payload }) => payload,
    retore: () => initialState,
  },
});

export const {
  setAddOns,
  activeAddOns,
  addTicketInsurance,
  removeTicketInsurance,
  eneableTicketInsurance,
  disableTicketInsurance,
  setTicketInsurancePrice,
  restoreTicketInsurance,
  setNotHealthy,
  setAddons,
  retore,
} = slice.actions;

export default slice.reducer;
